/**
 * Formie Events
 *
 * Formie - Tag Manager integration
 */
const formieEvents = () => {
	const forms = document.querySelectorAll(".fui-form")
	;[...forms].forEach((form) => {
		let formConfig = form.dataset.fuiForm ?? ""
		try {
			formConfig = JSON.parse(formConfig)
		} catch (e) {
			formConfig = {}
		}
		const formHandle = formConfig.formHandle ?? "unknown"
		form.addEventListener("onAfterFormieSubmit", (e) => {
			e.preventDefault()
			const data = e.detail
			if (data.success && data.nextPageIndex == 0) {
				window.dl = window.dl || []
				window.dl.push({
					event: "formSubmission",
					formHandle: formHandle,
				})
			}
		})
		form.addEventListener("onFormieValidate", (e) => {
			const data = e.detail
			if (data.invalid) {
				window.dl = window.dl || []
				window.dl.push({
					event: "formError",
					formHandle: formHandle,
				})
			}
		})
	})
}

document.addEventListener("DOMContentLoaded", function () {
	formieEvents()
})

export default formieEvents
